module.exports = __webpack_public_path__ + "assets/images/CAD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CAD100.png
// module id = 1327
// module chunks = 1